export default __webpack_public_path__ + "images/30274caa375d219c98527cf822dede8b-warning-triangle.svg";